<template>
  <div class="timmer">
    <label :style="quizMessage" class="is-size-3-desktop">{{ formattedElapsedTime }}</label>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'TotalTimer',
  computed: {
    ...mapGetters(['formattedElapsedTime','primaryColor']),
    quizMessage(){
      return{
        "color": this.primaryColor
        
      }
    }
  },
};
</script>
